import { ENDPOINT } from '~/constants/endpoints';

import { type UUID } from '~/types/common';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasPublicApi } from '~/services/kyClient';

import { type SupplierActivationPublicResponse } from './types';
import { zodSupplierActivationPublicResponseSchema } from './validations';

/**
 * Fetches the public view of a supplier activation request using a magic link token.
 *
 * This is a public endpoint — no authentication required. The `token` query
 * parameter acts as the authorization credential.
 *
 * @param reqId - The activation request ID.
 * @param token - The magic link token from the supplier's email.
 * @param options - Optional ky request options (e.g., abort signal).
 * @returns The public activation request view.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Suppliers-(Public)/operation/get_supplier_activation_public_api_v1_suppliers_actions__req_id__get
 */
export const fetchSupplierActivationPublic = async (
  reqId: UUID,
  token: string,
  options?: KyRequestOptions,
) =>
  vestigasPublicApi
    .get(ENDPOINT.SUPPLIER.GET_ACTIVATION_PUBLIC(reqId), {
      ...options,
      searchParams: { token },
      validate: {
        ...options?.validate,
        response: zodSupplierActivationPublicResponseSchema,
      },
    })
    .json<SupplierActivationPublicResponse>();
